import { daysRange } from 'app/constants/dates';
import { DrivingViolationsState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const drivingViolationsState: DrivingViolationsState = {
  refetchDataCount: 0,
  isRequestPending: false,
  isExportDataRequestPending: false,
  fileUpload: {
    file: null,
    note: '',
    userId: '',
    driverViolationId: '',
    isRequestPending: false,
  },
  // Modal toggle
  isToggleExportFileModal: false,
  isToggleFileUploadModal: false,
  isToggleDrivingViolationsModal: false,
  // Filters
  driver: null,
  terminal: null,
  subset: null,
  violation: null,
  dateRange: {
    fromDate: daysRange.minDay.toISODate(),
    toDate: daysRange.maxDay.toISODate(),
  },
  // Sorting (newest first by default)
  sortBy: '-timestamp',
  sortField: 'timestamp',
  // Pagination
  limit: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
  totalRecordCount: 0,
  // Data source
  violations: [],
  driverCalcs: [],
  driverViolationDetails: null,
  // Export file data source
  documentType: 'pdf',
  violationsExportData: [],
  documentUploadedFromCompModel: false,
};
